import * as types from '../mutation-types'

import Vue from 'vue'

const SETTINGS = 'settings'
const PRINTCOUNT = 'printCount'

// initial state
const state = {
  is_fast: window.localStorage.getItem(SETTINGS) === 'true' ? true : false,
  count: parseInt(window.localStorage.getItem(PRINTCOUNT)) || 1
};

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
let mutations = {}

mutations[types.SET_IS_FAST] = function (state, r) {
  state.is_fast = r;
  window.localStorage.setItem(SETTINGS, r);
}

mutations[types.SET_COUNT] = function (state, r) {
  state.count = r;
  window.localStorage.setItem(PRINTCOUNT, r);
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js